module.exports = __webpack_public_path__ + "img/Hp-IconBox3-Global-demand.a316dbdc.svg";